import { MissionToStaff } from '../../lib/types/models/mission-to-staff/mission-to-staff'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function confirmStaff(input: { id: number; staffId: number }) {
  const { id, staffId } = input
  return restApiClient
    .url(constructApiUrl(API.missions.confirmStaff.url, { id, staffId }))
    .post<MissionToStaff>()
}
